import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import type { MeteringOrMarketLocation } from "../utils/backend-types";
import { meteringOrMarketLocationQueries } from "./useMeteringOrMarketLocation";

interface UseMeteringOrMarketLocationsParams {
  siteId?: number;
  variantId?: number;
  options?: Partial<UseQueryOptions<Array<MeteringOrMarketLocation>>>;
}

export function useMeteringOrMarketLocations({
  siteId,
  variantId,
  options
}: UseMeteringOrMarketLocationsParams) {
  return useQuery({
    ...meteringOrMarketLocationQueries.list({ siteId, variantId }),
    ...options
  });
}
